import TreatmentPage from "./TreatmentPage";

export default function TattooRemoval() {
  return (
    <TreatmentPage
      title="Tattoo Removal"
      heroImage="/treatment/tattoo-removal-drTruptis-clinic.png"
      intro="Laser tattoo removal is the most common, non-invasive method, utilizing specialized, high-intensity light  to break down ink pigments into smaller particles for the body to eliminate."
      description="Tattoo removal is the process of eliminating unwanted ink from the skin."
      howItWorks="With the  help of high intensity light to  break down the ink pigments into smaller particles for the body to eliminate."
      benefits={[
        "Long lasting Result",
        "Minimal damage of surrounding tissue.",
        "Painless procedure.",
      ]}
      beforeAfterImages={[
        "/Treatment/before-tattoo-removal-truptis-clinic.jpeg",
        "/treatment/after-tattoo-removal-truptis-clinic.jpeg",
      ]}
      faqs={[
        { q: "Is it painful?", a: "Mild discomfort only, done under cooling gel." },
        { q: "How many sessions needed?", a: "Usually 8-10 sessions." },
      ]}
    />
  );
}
